import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs';

const ICONS: string[] = [
  'alert',
  'arrow-back',
  'calendar',
  'checkbox-off',
  'checkbox-on',
  'icon-dashboard',
  'icon-policies',
  'empty-doc',
  'icon-box',
  'icon-claims',
  'icon-customers',
  'icon-finance',
  'icon-forex',
  'icon-users',
  'icon-user',
  'icon-invoices',
  'icon-reports',
  'icon-logout',
  'icon-bell',
  'icon-chevron-down',
  'icon-refresh',
  'empty-doc',
  'dollar',
  'groups',
  'plus',
  'upload_file',
  'download_file',
  'select-icon',
  'select-circle',
  'description',
  'description_outline',
  'currency_exchange',
  'close',
  'clock',
  'cancel_outline',
  'certificate_stock',
  'settings',
  'bar_chart',
  'mail',
  'cancel',
  'flash',
  'search',
  'suitcase',
  'trending_up',
  'track',
  'export',
  'download',
  'info',
  'upload',
  'help-outline',
  'delete-row',
  'delete',
  'error-outline',
  'add',
  'edit',
  'nav-arrow',
  'print',
  'shield-check',
  'shield-off',
  'check',
  'alert-circle',
  'x',
  'truck',
  'phone',
  'subscription',
  'paperclip',
  'eye',
  'eye-off',
];

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    const router = inject(Router);
    const document = inject(DOCUMENT);

    for (const name of ICONS) {
      iconRegistry.addSvgIcon(
        name,
        sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`),
      );
    }

    router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => {
      if (e.urlAfterRedirects.startsWith('/comesa')) {
        document.body.classList.add('theme-comesa');
      } else {
        document.body.classList.remove('theme-comesa');
      }
    });
  }
}
